import React, { useContext } from "react";

import './links.css';
import Button from "../button/button";
import { clearToken } from "../../utils/token";
import { UserDataContext } from "../../contexts";


function Links() {
    const { refetchStatus } = useContext(UserDataContext);
  return (
    <section className="contacts-section">

      <p className="organizer-text">
        По всем вопросам вы можете<br />
        обращаться к нашему<br />
        свадебному организатору
      </p>

      <div className="icons-group">
        <a href='https://t.me/girlmostlikelyto' target="_blank" aria-label="Telegram" rel="noreferrer">
          <img src="/icons/telegram.svg" alt="Telegram" />
        </a>
      </div>

      <Button
        text='Выйти'
        onClick={ async () => {
          clearToken();
          await refetchStatus();
        }}
      />
    </section>
  );
}

export default Links;